import { isReactNativeApp, postReactNativeMessage } from './mobileRNApp';
export const openWindow = (url, target = '_blank') => {
    if (isReactNativeApp()) {
        postReactNativeMessage(JSON.stringify({ type: 'file-download', url }));
        return null;
    }
    const win = window.open(url, target);
    return win;
};
